import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getChapter } from "./api";
import { loaderStart, loaderEnd } from "../../components/loader"

import '../Question-bank/questionbank.css'
import './chapterpage.css'

const ChapterPage = () => {
    const { ...params } = useParams()
    const [data, setData] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (params.code) {
            getData()
        }
    }, [])

    const getData = async () => {
        // The screen previously fetched with no loading indicator at all, so it
        // sat blank and looked broken until the response landed.
        loaderStart()
        let data = await getChapter(params.code, params.lang)
        if (data.code) {
            setData(data.data)
        }
        setLoaded(true)
        loaderEnd()
    }

    const totalQuestions = data.reduce((n, d) => n + (Number(d.total_count) || 0), 0)

    return (
        <div className='qb_page'>
            <nav className='qb_crumbs'>
                <Link to='/question-bank'>Question Bank</Link>
                <span className='qb_crumb_sep'>/</span>
                <Link to={`/subject-page?lang=${params.lang}`}>Subjects</Link>
                <span className='qb_crumb_sep'>/</span>
                <span>{params.code}</span>
            </nav>

            <div className='qb_header'>
                <h1 className='qb_title'>Chapters</h1>
                <p className='qb_subtitle'>
                    Subject <b>{params.code}</b>
                    {data.length > 0
                        ? ` · ${data.length} chapter${data.length === 1 ? '' : 's'} · ${totalQuestions} questions`
                        : ''}
                </p>
            </div>

            {data.length > 0 ? (
                <div className='qb_grid'>
                    {data.map((d) => (
                        // Opened via window.open on a div before — no keyboard access
                        // and no middle-click. A real link behaves like a link.
                        <Link
                            key={d.topic_code}
                            to={`/questions/${d.topic_code}`}
                            target='_blank'
                            rel='noreferrer'
                            className='qb_card'
                        >
                            <span className='qb_card_code'>{d.topic_code}</span>
                            <p className='qb_card_name'>{d.topic_name}</p>
                            <span className='qb_card_meta'>
                                <span className='qb_pill'>{d.total_count}</span>
                                questions
                            </span>
                            <i className='fa fa-file-text qb_card_icon' aria-hidden='true'></i>
                        </Link>
                    ))}
                </div>
            ) : loaded ? (
                <p className='qb_empty'>No chapters are available for this subject yet.</p>
            ) : null}
        </div>
    )
}

export default ChapterPage
